import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosRestaurantInstance from "./AxiosRestaurantInstance";
import FloatingLabelInput from "./PlaceHolder";
import styles from "./css/SignIn.module.css";
// Import images
import logo from "./assets/junior-eats-logo.png";
import bike from "./assets/bike.png";
import restaurant from "./assets/Restaurant.png";
import children from "./assets/children.png";

const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await getUser({ email, password });
  
      if (response.status === 200) {
        const { data } = response;
        const { user } = data;
  
        if (user) {
          const userRole = user.userRole;
  
          if (userRole === "ROOT_ADMIN") {
            localStorage.setItem("Token", response.headers.get("X-Auth-Token"));
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem("restaurantId", user.restaurantId);
            navigate("/home", { state: { user } });
          } else {
            alert("Access denied: Only ROOT_ADMIN users can log in.");
          }
        } else {
          alert("Login failed: User data is missing in the response");
        }
      } else {
        alert(
          "Login failed: " + (response.data.message || "Unknown error occurred")
        );
      }
    } catch (error) {
      console.error("Login error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "An unexpected error occurred. Please try again.";
      alert("An error occurred during login: " + errorMessage);
    }
  };
  

  return (
    <div className={styles.signin_container}>
      {/* Left section: Background and visuals */}
      <div className={styles.signin_leftSection}>
        {/* <img src={background} alt="Background" className={styles.background} /> */}
        <div className={styles.signin_imageGroup}>
          <img src={bike} alt="bike" className={styles.signin_bike} />
          <img
            src={restaurant}
            alt="Restaurant"
            className={styles.signin_restaurant}
          />
           
          <img
            src={children}
            alt="Children Eating"
            className={styles.signin_children}
          />
        </div>
      </div>

      {/* Right section: Login form */}
      <div className={styles.signin_rightSection} style={{marginLeft:'0px',marginBottom:'0px',height:'auto'}}>
        <img src={logo} alt="Junior Eats Logo" className={styles.signin_logo} />

        <form onSubmit={handleSubmit} className={styles.signin_form}>
          <h3>Restaurant</h3>
          <FloatingLabelInput
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            label="Enter Email"
            isRequired={true}
          />
          <div
            style={{
              position: "relative",
              width: "100%",
              textAlign: "right",
              marginBottom: "-20px",
              marginTop: "-16px",
            }}
          >
            <a
              className={styles.signin_forgotPassword}
              style={{
                float: "right",
                marginRight: "-0px",
                fontFamily:'sans-serif',
                fontSize: "12px",
                fontWeight: "500",
                color: "#007bff",
              }}
              href="/restaurant/forgotpassword"
            >
              Forgot Password
            </a>
          </div>
          {/* <a className={styles.signin_forgotPassword} href="/restaurant/forgotpassword">Forgot Password</a> */}
          <FloatingLabelInput
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            label="Enter Password"
            isRequired={true}
          />
          <button type="submit" className={styles.signin_button}>
            Sign In
          </button>
        </form>
        <div className={styles.linkSection}
       
        >
          <span>Don't have an account?</span>
          <a
            
            href="/restaurant/signup"
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              color: "#007bff",
              textAlign: "center",
              textDecoration: "none",
            }}
          >
            Sign Up
          </a>
          
          <a
            // className="signin_home"
            href="https://jreats.com/"
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              color: "#007bff",
              textAlign: "center",
              textDecoration: "none",
            }}
          >
            Home
          </a>
          
        </div>
      </div>
    </div>
  );
};

// Helper function to make the API call for login
export const getUser = async (formData) => {
  return await axiosRestaurantInstance.post("/login", formData);
};

export default Signin;
